import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { NumberConstants } from '../constants/number';

/**
 * Use this pipe to keep desired number values to XBS's standard number format.
 */

@Pipe({ name: 'xbsNumberFormat' })
export class XbsNumberFormatPipe implements PipeTransform {

  constructor(private _decimalPipe: DecimalPipe) { }

  transform(value: any): string {
    let formattedNumber: string;

    if (Number.isInteger(Number(value))) {
      formattedNumber = this.formatToLocaleStringWithoutDecimals(value);
    } else {
      formattedNumber = this.formatToLocaleStringWithDecimals(value);
    }

    return formattedNumber;
  }

  private formatToLocaleStringWithoutDecimals(value: number): string {
    return this._decimalPipe.transform(value);
  }

  private formatToLocaleStringWithDecimals(value: number): string {
    return this._decimalPipe.transform(value, `1.${NumberConstants.DECIMAL_AMOUNT}-${NumberConstants.DECIMAL_AMOUNT}`);
  }

}
